import { MetaResource } from '@shared/interfaces/paged-resource';

export interface OrdersWithDeliveryStateModel {
  visibleColumns: string[];
}

export class SetVisibleColumns {
  static readonly type = '[OrdersWithDelivery] Set Visible Columns';

  constructor(public columns: string[]) {}
}

export class SetMeta {
  static readonly type = '[OrdersWithDelivery] Set Meta';

  constructor(public meta: MetaResource) {}
}
